export enum SubBatchSetupStatus {
  UNSET_SETUP_STATUS = 'UNSET_SETUP_STATUS', // Do not use, needed because of proto3 limitations
  SETUP_PENDING = 'SETUP_PENDING',
  SETUP_PROCESSING = 'SETUP_PROCESSING',
  SETUP_COMPLETED = 'SETUP_COMPLETED',
}
